//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconFileSecurity(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15.41 2L20 6.59V8H14V4H6V20H18V10H20V22H4V2H15.41Z" fill="currentColor" /><path d="M16 10H8V13.4918C8 16.7478 10.0578 18.0441 12 19C13.9467 18.0441 16 16.7478 16 13.4918V10ZM11.7778 15.4209L10.3511 14.0199L10.9822 13.4001L11.7778 14.1814L13.4622 12.5272L14.0889 13.1426L11.7778 15.4209Z" fill="currentColor" /></svg>;
}
export default IconFileSecurity;